import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLiff } from "react-liff";

import MainLayout from "./layouts/MainLayout";
import PageLoader from "./components/loader/PageLoader";

import AppRouter from "./appRouter"; // Router

import { setProfile } from "./features/ProfileSlice";
import { accessToken } from "./services/Api/Module/Customer";

import VConsole from "vconsole";

// const devMode = false;

function App() {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);

  const [isLoadedProfile, setIsLoadedProfile] = useState(false);
  const [isHasProfile, setIsHasProfile] = useState(false);

  let { error, isLoggedIn, isReady, liff } = useLiff();

  // if (!isLoggedIn && devMode) {
  //   isLoggedIn = devMode; // mock true เอาไว้ dev
  // }

  const initialized = useRef(false);

  useEffect(() => {
    // console.log("isLoggedIn >>", isLoggedIn);

    if (error) {
      console.warn(error);
      setIsLoadedProfile(true); // Set to true even on error to prevent infinite loading
      return;
    }

    if (!isReady || !isLoggedIn || !liff) return;

    if (!initialized.current) {
      initialized.current = true;

      (async () => {
        try {
          const profile = await liff.getProfile();

          if (profile) {
            const sub = liff.getDecodedIDToken().sub;
            // console.log(profile, sub);

            let tmpObj = {
              lineUid: sub,
            };

            if (profile.pictureUrl) {
              tmpObj.lineImgUrl = profile.pictureUrl;
            }
            // console.log(tmpObj);

            getAccessToken({
              lineUid: sub,
            }).then((_rsData) => {
              // console.log("_rsData >>", _rsData);

              if (typeof _rsData.result?.token !== "undefined") {
                window.localStorage.setItem("token", _rsData.result.token);
              }

              if (_rsData.status === true) {
                // console.log(sub, _rsData.result);

                if (_rsData.result?.id !== undefined) {
                  tmpObj = {
                    ...tmpObj,
                    id: _rsData.result.id,
                  };

                  setIsHasProfile(true);
                }

                dispatch(setProfile(tmpObj));
              }

              setIsLoadedProfile(true); // Always set to true after getAccessToken completes
            }).catch((err) => {
              console.warn("Error in getAccessToken:", err);
              setIsLoadedProfile(true); // Set to true even on error
            });
          } else {
            setIsLoadedProfile(true); // Set to true if no profile
          }
        } catch (error) {
          console.warn(error);
          setIsLoadedProfile(true); // Set to true even on error
        }
      })();
    }
  }, [error, isReady, isLoggedIn, liff, dispatch]);

  useEffect(() => {
    // console.log("isLoadedProfile >>", isLoadedProfile, isHasProfile);
    if (isLoadedProfile) {
      const vConsole = new VConsole();
    }
  }, [isLoadedProfile, isHasProfile]);

  const getAccessToken = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await accessToken({ lineUid: payload.lineUid });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getAccessToken resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR getAccessToken >> ", e);
    }

    return _return;
  };

  return (
    <>
      {!isReady ? (
        <PageLoader />
      ) : !isLoadedProfile ? (
        <PageLoader />
      ) : (
        <MainLayout>
          <AppRouter isHasProfile={isHasProfile} profileData={stateProfile} />
        </MainLayout>
      )}
    </>
  );
}

export default App;
